import { render, staticRenderFns } from "./ctlQuoteListTableView.vue?vue&type=template&id=55d2db07&"
import script from "./ctlQuoteListTableView.vue?vue&type=script&lang=js&"
export * from "./ctlQuoteListTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ctlQuoteListTableView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VDataTable,
})
